import { idbDriver } from './idbDriver'

const MIGRATION_FLAG = '@@remember-migrated-to-idb'

const REMEMBER_KEYS = [
  '@@remember-route',
  '@@remember-planner',
  '@@remember-mapPreferences',
  '@@remember-personalPoi',
  '@@remember-userPreferences',
]

export async function migrateLocalStorageToIdb(): Promise<void> {
  if (localStorage.getItem(MIGRATION_FLAG)) {
    return
  }

  const entries: Array<{ key: string; value: string }> = []

  for (const key of REMEMBER_KEYS) {
    const value = localStorage.getItem(key)
    if (value !== null) {
      entries.push({ key, value })
    }
  }

  for (const entry of entries) {
    await idbDriver.setItem(entry.key, entry.value)
  }

  for (const key of REMEMBER_KEYS) {
    localStorage.removeItem(key)
  }

  localStorage.setItem(MIGRATION_FLAG, '1')
}
